export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('vue:error', (error, instance, info) => {
    // 处理错误，例如报告到某个服务
    console.error('Vue Error Captured:', {
      message: error?.message,
      stack: error?.stack,
      info
    })
  })
})
